import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  padding: 80px 24px 0;
  max-width: 880px;
  margin: 0 auto;
`;

const Head = styled.div`
  margin-bottom: 48px;
`;

const Kicker = styled.div`
  font-size: 0.8rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--accent-2);
  font-weight: 600;
  margin-bottom: 12px;
`;

const Title = styled.h1`
  font-family: 'Space Grotesk', sans-serif;
  font-size: clamp(2.2rem, 5vw, 3.2rem);
  margin: 0 0 12px;
  letter-spacing: -0.02em;
`;

const Date = styled.p`
  margin: 0;
  color: var(--text-mute);
  font-size: 0.95rem;
`;

const Body = styled.div`
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 24px;
  padding: 40px;
  color: var(--text-dim);
  line-height: 1.75;
  font-size: 1rem;
  @media (max-width: 640px) {
    padding: 28px 22px;
  }

  h2 {
    font-family: 'Space Grotesk', sans-serif;
    color: var(--text);
    font-size: 1.35rem;
    margin: 36px 0 14px;
    letter-spacing: -0.01em;
  }
  h2:first-child { margin-top: 0; }

  h3 {
    font-family: 'Space Grotesk', sans-serif;
    color: var(--text);
    font-size: 1.05rem;
    margin: 24px 0 10px;
  }

  p { margin: 0 0 14px; }

  ul {
    margin: 0 0 18px;
    padding-left: 22px;
  }
  li { margin-bottom: 8px; }

  a {
    color: var(--accent-2);
    border-bottom: 1px solid rgba(255, 61, 127, 0.4);
    transition: border-color 0.2s ease;
    &:hover { border-color: var(--accent-2); }
  }

  strong { color: var(--text); }

  hr {
    border: none;
    border-top: 1px solid var(--border);
    margin: 32px 0;
  }
`;

export default function LegalPage({ kicker, title, date, children }) {
  return (
    <Wrap>
      <Head>
        <Kicker>{kicker}</Kicker>
        <Title>{title}</Title>
        <Date>{date}</Date>
      </Head>
      <Body>{children}</Body>
    </Wrap>
  );
}
